import React from 'react';
import Styles from './BensServicosPF.css';
import BensServicosPFParcelaFacilitada from '@/components/organisms/BensServicosPFParcelaFacilitada';
import BensServicosPFConfiraPassoAPasso from '@/components/organisms/BensServicosPFConfiraPassoAPasso';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import BensServicosBuscaLojas from '@/components/organisms/BensServicosBuscaLojas';

function BensServicosPF() {
  const faqTitle = 'Saiba mais sobre a compra de bens parcelados no boleto';
  const imgpng = 'assets/bens-e-servicos/perguntas-pf/img-perguntas.png';
  const imgwebp = 'assets/bens-e-servicos/perguntas-pf/img-perguntas.webp';
  const imgpngdesk = 'assets/bens-e-servicos/perguntas-pf/img-perguntas-desk.png';
  const imgwebpdesk = 'assets/bens-e-servicos/perguntas-pf/img-perguntas-desk.webp';
  const imgalt =
    'Pessoa usando smartphone em ambiente aconchegante, representando a praticidade do crédito pessoal, empréstimo para empresas e bens e serviços parcelados com Santander Financiamentos.';
  const linkMostrarTodasPerguntas = 'duvidas-frequentes.html';
  const faqs = [
    {
      pergunta: 'O parcelamento da compra está disponível para compras online e físicas?',
      resposta: `Apenas é possível realizar o parcelamento de forma física.`,
      startOpen: true,
    },
    {
      pergunta: 'É necessário um valor mínimo de compra para usufruir do parcelamento da compra?',
      resposta: `Não é necessário um valor mínimo de compra para usufruir do parcelamento. O parcelamento está disponível para todas as compras, independentemente do valor.`,
    },
    {
      pergunta:
        'É possível realizar o parcelamento da compra de mais de uma categoria de produtos no mesmo parcelamento?',
      resposta: `Não, parcelamento é específico para uma categoria de produto. No entanto, você pode solicitar parcelamentos separados para diferentes categorias de produtos, se desejar.`,
    },
    {
      pergunta: 'É necessário ter cartão de crédito para realizar o parcelamento da compra?',
      resposta: `Não é necessário ter cartão de crédito para realizar o parcelamento. O parcelamento pode ser feito através de outras formas de pagamento, como boleto bancário ou débito em conta. *
      <br/>
      *O parcelamento ocorre por meio de um lojista parceiro da Aymoré.`,
    },
    {
      pergunta: 'Quantas parcelas posso realizar o parcelamento?',
      resposta: `Você pode parcelar em até 96 vezes, de acordo com o valor da compra, categoria do produto e a sua análise de crédito.`,
    },
    {
      pergunta: 'Qual a vantagem de realizar parcelamento em vez de usar o cartão de crédito?',
      resposta: `A vantagem do parcelamento é oferecer maior flexibilidade e controle financeiro pois não compromete o limite do cartão de crédito`,
    },
    {
      pergunta: 'O que fazer caso queira cancelar o parcelamento?',
      resposta: `Em caso de cancelamento do produto adquirido você deve solicitar o cancelamento na loja em que realizou o parcelamento da compra.`,
    },
  ];
  return (
    <>
      <BensServicosPFParcelaFacilitada />
      <BensServicosPFConfiraPassoAPasso />
      <BensServicosBuscaLojas />
      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosPF;
